// extracted by mini-css-extract-plugin
export var nameAndLocation = "ProjectFieldRow-module--nameAndLocation--wwEsE";
export var project = "ProjectFieldRow-module--project--CnBYq";
export var projectWithGallery = "ProjectFieldRow-module--projectWithGallery--T2Pfa";
export var viewGallery = "ProjectFieldRow-module--viewGallery--IwKfo";